import React, { useEffect, useState } from "react";
import PaginatedItems from './PaginatedItems';
import axios from "axios";
import { useLocation } from "react-router-dom";
import { logo } from "../../assets/images";
import { useTranslation } from "react-i18next";

const Products = () => {
  const { t, i18n } = useTranslation();
  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOption, setSortOption] = useState("default");
  const [category3Filters, setCategory3Filters] = useState({});
  const [category2Filters, setCategory2Filters] = useState({});
  const [category1Filters, setCategory1Filters] = useState({});
  const [priceFilter, setPriceFilter] = useState("default");
  const [category2Search, setCategory2Search] = useState("");
  const [category3Search, setCategory3Search] = useState("");
  const [isLoading, setIsLoading] = useState(true)


  const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false);
  const toggleHamburgerMenu = () => setIsHamburgerMenuOpen(!isHamburgerMenuOpen);

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://www.tanura.az/tanura/dashboard.php`,
        { withCredentials: false }
      );
  

      setProducts(response.data.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleCategory2Change = (category2) => {
    setCategory2Filters((prev) => ({
      ...prev,
      [category2]: !prev[category2],
    }));
  };

  const handleCategory3Change = (category3) => {
    setCategory3Filters((prev) => ({
      ...prev,
      [category3]: !prev[category3],
    }));
  };

  const handleCategory1Change = (category1) => {
    setCategory1Filters((prev) => ({
      ...prev,
      [category1]: !prev[category1],
    }));
  };

  const handlePriceChange = (price) => {
    setPriceFilter(price);
  };

  const clearCategory2Filters = () => {
    setCategory2Filters({});
    setCategory2Search("");
  };

  const clearCategory3Filters = () => {
    setCategory3Filters({});
    setCategory3Search("");
  };

  // Filtering logic
  const filteredProducts = products.filter(product => {
    const matchesSearch = product.name.toLowerCase().includes(searchQuery.toLowerCase());

    // Check if brand filters are applied
    const hasSelectedCategory2 = Object.keys(category2Filters).some(key => category2Filters[key]);
    const matchesCategory2 = !hasSelectedCategory2 || category2Filters[product.category2];

        // Check if brand filters are applied
        const hasSelectedCategory3 = Object.keys(category3Filters).some(key => category3Filters[key]);
        const matchesCategory3 = !hasSelectedCategory3 || category3Filters[product.category3];

    // Check if gender filters are applied
    const hasSelectedCategory1 = Object.keys(category1Filters).some(key => category1Filters[key]);
    const matchesCategory1 = !hasSelectedCategory1 || category1Filters[product.category1];

    return matchesSearch && matchesCategory2 && matchesCategory3 && matchesCategory1;
  });

  // Sort products based on the selected option
  const sortedProducts = [...filteredProducts].sort((a, b) => {
    if (sortOption === "lowToHigh") {
      return a.price - b.price; // Sort ascending by price
    } else if (sortOption === "highToLow") {
      return b.price - a.price; // Sort descending by price
    }
    return 0; // No sorting
  });

  // Apply price filter
  const finalProducts = priceFilter === "default" ? sortedProducts : sortedProducts.filter(product => {
    if (priceFilter === "low") return product.price > 100 && product.price < 200; // Example: products priced below 50
    if (priceFilter === "high") return product.price > 200 && product.price < 300; // Example: products priced 50 and above
    if (priceFilter === "highh") return product.price > 300 && product.price < 400; // Example: products priced 50 and above
    if (priceFilter === "highhh") return product.price > 400 && product.price < 500; // Example: products priced 50 and above

    return true;
  });

  // Brands to display (for example purposes)
  const allCategory2 = [
    "Saç", "Bədən", "Üz",
  ];

  const allCategory3 = [
    "Bütün", "Həssas", "Qarışıq və yağlı", "Quru və normal", "Səpkili",
  ];

  // Filter brands based on search input
  const filteredCategory2 = allCategory2.filter(category2 =>
    category2.toLowerCase().includes(category2Search.toLowerCase())
  );

  const filteredCategory3 = allCategory3.filter(category3 =>
    category3.toLowerCase().includes(category3Search.toLowerCase())
  );

  return (
    <>
      <div className="mt-5 md:mt-10">
        <p className='text-[22px] md:text-[28px] font-semibold text-center'>{t("Məhsullar")}</p>
        
        <div className='md:flex max-w-containerSm md:max-w-container mx-auto mt-8 justify-between'>
          {/* Left Filter Section */}
          <div className="md:w-[273px] md:block">

            <div className="mt-4">
  <label className="text-black font-medium mb-7">{t("Kateqoriya")}:</label>
  <div className="flex flex-col">
    {["ev", "kabin", "set"].map((category1) => {
      const labelMap = {
        ev: "Ev qulluq məhsulları",
        kabin: "Professional baxım məhsulları",
        set: "Set məhsulları",
      };

      return (
        <div key={category1}>
          <input
            type="checkbox"
            id={category1}
            checked={!!category1Filters[category1]}
            onChange={() => handleCategory1Change(category1)}
            className="accent-[#dfb66f]" 
          />
          <label htmlFor={category1} className="ml-2 text-black">
            {t(labelMap[category1])}
          </label>
        </div>
      );
    })}
  </div>
</div>

            <div className="w-[211.01px] h-[0px] border border-[#3e3e3e] mt-4"></div>
            
            <div className="mt-4">
             <div className="flex justify-between">
             <label className='text-black'>{t("Alt kateqoriyalar")}:</label>
              <button
                  onClick={clearCategory2Filters}
                  className="text-[#5b5b5b] rounded"
                >
                  {t("Təmizlə")}
                </button>
             </div>
              <div className="flex flex-col mt-2 max-h-48">
                {filteredCategory2.map((category2) => ( // Show only the first 3 brands
                  <div key={category2}>
                    <input
                      type="checkbox"
                      id={category2}
                      checked={!!category2Filters[category2]}
                      onChange={() => handleCategory2Change(category2)}
                      className="accent-[#dfb66f]" 
                    />
                    <label htmlFor={category2} className="ml-2 text-black">{t(category2.charAt(0).toUpperCase() + category2.slice(1))}</label>
                  </div>
                ))}
              </div>
            </div>

            <div className="w-[211.01px] h-[0px] border border-[#3e3e3e] mt-4"></div>
            
            <div className="mt-4">
             <div className="flex justify-between">
             <label className='text-black'>{t("Dəri tipinə görə")}:</label>
              <button
                  onClick={clearCategory3Filters}
                  className="text-[#5b5b5b] rounded"
                >
                  {t("Təmizlə")}
                </button>
             </div>
              <div className="flex flex-col mt-2 max-h-48">
                {filteredCategory3.map((category3) => ( // Show only the first 3 brands
                  <div key={category3}>
                    <input
                      type="checkbox"
                      id={category3}
                      checked={!!category3Filters[category3]}
                      onChange={() => handleCategory3Change(category3)}
                      className="accent-[#dfb66f]" 
                    />
                    <label htmlFor={category3} className="ml-2 text-black">{t(category3.charAt(0).toUpperCase() + category3.slice(1))}</label>
                  </div>
                ))}
              </div>
            </div>

          </div>

          {/* Products Section */}
          <div className="md:w-[985px]">
            <div className="flex justify-between mb-4">
            </div> 
            {isLoading ?  <p className="text-[white]"> Loading...</p> :
              <PaginatedItems itemsPerPage={12} items={finalProducts} />  
            }
           
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;


















































